// @flow
import React from 'react';
import InnerForm from '../components/InnerForm';
import { vehicleTariffEnum } from '../../../lib/enum';

type Props = {
  vehicleTariffId: number
};

export const VehicleTariffTypeForm = ({ vehicleTariffId }: Props) => {
  return (
    <>
      <InnerForm
        vehicleTariffId={vehicleTariffId}
        type={vehicleTariffEnum.byType}
      />
    </>
  );
};

export default VehicleTariffTypeForm;
